import { Page } from "@/config/models"
import { pagePermissions } from "@/config/permissions"

export function usePermissions() {

    // TODO: This should come from the CFS Authorization API, not be hardcoded.
    const currentUserPermissions = ["Dashboard.Read", "Subscriptions.Read", "Invoices.Read", "PaymentMethods.Read"]
  
    const hasPagePermission = (page: Page) => {        
        const requiredPermissions = pagePermissions[page]

        if (requiredPermissions.some(permission => currentUserPermissions.includes(permission))) {
            return true
        }

        return false
    }

  return {
    hasPagePermission
  }
}
